import React from "react";

const About = ({ about }) => {
  return (
    <div className="">
      <p className="mb-4 mt-3 poly f-36 ">About</p>
      <div dangerouslySetInnerHTML={{ __html: about }} />
      </div>
  );
};

export default About;
